import { z } from "zod";
import { applicationIdsSchema } from "./scheduleApplication.schema";
import { scheduleDeleteJournalEntryModeSchema } from "./scheduleLifecycle.schema";
import { scheduleApplicationBulkFailureSchema } from "./scheduleBulkFailure.schema";

export const deleteScheduleApplicationsBulkBodySchema = z.object({
    entityId: z.number().int().positive(),
    applicationIds: applicationIdsSchema,
    journalEntryMode: scheduleDeleteJournalEntryModeSchema,
});

export const deleteScheduleApplicationsBulkResponseSchema = z.object({
    removed: z.array(z.object({ applicationId: z.string().uuid() })),
    failed: z.array(scheduleApplicationBulkFailureSchema),
});

export type DeleteScheduleApplicationsBulkBody = z.infer<
    typeof deleteScheduleApplicationsBulkBodySchema
>;

export type DeleteScheduleApplicationsBulkResponse = z.infer<
    typeof deleteScheduleApplicationsBulkResponseSchema
>;
